// src/widget.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { I18nextProvider } from "react-i18next";
import i18n from "./data/translations";

const renderWidget = (containerId, guestForm = false) => {
  const container = document.getElementById(containerId);
  const initialValues = {
    fullName: document.getElementById("e2g_user_name")?.textContent || '',
    companyName: document.getElementById("e2g_user_company")?.textContent || '',
    email: document.getElementById("e2g_user_email")?.textContent || '',
    phoneNumber: document.getElementById("e2g_user_phone")?.textContent || '',
    street: document.getElementById("e2g_user_street")?.textContent || '',
    zipCode: document.getElementById("e2g_user_zip")?.textContent || '',
    city: document.getElementById("e2g_user_city")?.textContent || '',
    vatId: document.getElementById("e2g_user_vat")?.textContent || '',
    country: document.getElementById("e2g_user_country")?.textContent || '',
  };

  if (container) {
    ReactDOM.render(<I18nextProvider i18n={i18n}><App guestForm={guestForm} initialValues={initialValues} /></I18nextProvider>, container);
  } else {
    console.error(`Container with id ${containerId} not found`);
  }
};

// Expose the render function to the global scope
window.renderWidget = renderWidget;